module.exports = __webpack_public_path__ + "img/group-icon.23e64c11.svg";